import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ams_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ams_token");
    if (token && !user) {
      setLoading(true);
      api.get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("ams_user", JSON.stringify(r.data));
        })
        .catch(() => {
          localStorage.removeItem("ams_token");
          localStorage.removeItem("ams_user");
        })
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loginAdmin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ams_token", data.token);
    localStorage.setItem("ams_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const sendOtp = async (phone) => {
    const { data } = await api.post("/auth/student/send-otp", { phone });
    return data;
  };

  const verifyOtp = async (phone, otp) => {
    const { data } = await api.post("/auth/student/verify-otp", { phone, otp });
    localStorage.setItem("ams_token", data.token);
    localStorage.setItem("ams_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginStudentEmail = async (email, password) => {
    const { data } = await api.post("/auth/student/login-email", { email, password });
    localStorage.setItem("ams_token", data.token);
    localStorage.setItem("ams_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ams_token");
    localStorage.removeItem("ams_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginAdmin, sendOtp, verifyOtp, loginStudentEmail, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
